import { z } from 'zod';

import { IdSchema } from '../../base/primitives';
import {
  TopicActionsSchema,
  TopicContentSchema,
  TopicNameSchema,
  TopicQuestionValueBaseSchema,
  TopicQuestionValueSchema,
} from './knowledge-base.schema';

// Jupiter UI-specific topic schemas with discriminated union for example queries
export const TopicQuestionBaseUISchema = z.object({
  value: TopicQuestionValueBaseSchema,
  isLast: z.boolean(),
});

export const TopicQuestionOldUISchema = z.object({
  value: TopicQuestionValueSchema,
  isLast: z.literal(false),
});

export const TopicQuestionNewUISchema = z.object({
  value: z.string(),
  isLast: z.literal(true),
});

export const TopicQuestionUISchema = z
  .discriminatedUnion('isLast', [
    TopicQuestionOldUISchema,
    TopicQuestionNewUISchema,
  ])
  .refine(data => !(data.isLast === false && data.value.length < 1), {
    message: 'This field is required.',
    path: ['value'],
  });

export const TopicUIFormSchema = z.object({
  id: IdSchema,
  name: TopicNameSchema,
  content: TopicContentSchema,
  actions: TopicActionsSchema,
  example_queries: z
    .array(TopicQuestionUISchema)
    .max(20)
    .transform(data => data.filter(v => !v.isLast))
    .transform(data => {
      return data.map(v => ({
        query: v.value,
      }));
    }),
  references: z.object({
    sms: z.object({}),
    handoff: z.object({}),
    attributes: z.object({}),
    globalFunctions: z.object({}),
    variables: z.object({}),
  }),
  active: z.boolean(),
  created_at: z.string(),
  updated_by: z.string(),
  updated_at: z.string(),
});

export type TopicUIForm = z.infer<typeof TopicUIFormSchema>;
